


import { useEffect, useState } from "react"
import styled from "styled-components"
import InputIsParsiyel from "../../shared/input/topPagesFilterInput/InputIsParsiyel"
import InputTruckType from "../../shared/input/topPagesFilterInput/InputTruckType"
import InputSelectCity from "../../shared/input/topPagesFilterInput/InputSelectCity"

import { FaSort, FaSortDown, FaSortUp   } from "react-icons/fa";
import InputPublishingType from "../../shared/input/topPagesFilterInput/InputPublishingType"
import InputYuklemeDate from "../../shared/input/topPagesFilterInput/InputYuklemeDate"
import BtnOutline from "../../shared/button/BtnOutline"
import { getLoadList, getSeferdeList, getSeferdeListAdmin, getYuklemedeList } from "../../../features/loadList/loadListSlice"
import { useDispatch } from "react-redux"
import moment from "moment"
import InputGonderici from "../../shared/input/topPagesFilterInput/InputGonderici"
import InputAlici from "../../shared/input/topPagesFilterInput/InputAlici"
import InputAracPlaka from "../../shared/input/topPagesFilterInput/InputAracPlaka"
import { useSelector } from "react-redux"
import { getTopPagesNotificationsCounts } from "../../../features/notification/notificationSlice"

const initialOrderDataList = [
  {
    id: 1,
    orderDirection: "eq",
    orderBy: "LoadCity"
  },
  {
    id: 2,
    orderDirection: "eq",
    orderBy: "UnLoadCity"
  },
  {
    id: 3,
    orderDirection: "eq",
    orderBy: "LoadDate"
  },
]

const Container = styled.div`

  width: 100%;
  min-height: 40px;
  background-color: ${({theme}) => theme.secondaryBgColor};
  display: flex;
  flex-direction: column;
  padding: 10px;
  border-radius: 15px;
  margin-bottom: 15px;

  .control-container{
    width: 100%;
    display: flex;
    align-items: center;

    .current-filter-list{
      margin: 0 20px;
      display: flex;
      align-items: center;
      gap: 15px;
      flex-wrap: wrap;

      .current-filter-item{
        font-size: var(--font-size-sm);
        font-size: 13px;
        font-weight: var(--font-weight-md);
        color: ${({theme}) => theme.mainTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        padding: 3px 7px;
        border-radius: 5px;
      }
    }
    

    .filter-show-btn{

      height: 36px;
      width: 150px;
      border-radius: 10px;
      background-color: ${({theme}) => theme.secondaryBgColor};
      background-color: ${({theme}) => theme.mainBgColor};
      color: ${({theme}) => theme.mainTextColor};
      padding: 0 20px;
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-lg);
      border: 1px solid ${({theme}) => theme.mainBorderColor};
    }
  }

  .filter-container{
    border-top: 1px solid ${({theme}) => theme.mainTextColor};
    padding: 5px 0;
    padding-top: 15px;
    width: 100%;
    height: auto;
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    .inner-grp{
      display: flex;
      height: min-content;
      align-items: center;
      gap: 5px;
      width: 22%;

      .arr-container{
        display: flex;
        flex-direction: column;
        cursor: pointer;


        .arr-icon{
          font-size: 1.3rem;
          color: ${({theme}) => theme.mainTextColor};
        }
      }
    }

  }

`
const SeferListTopContainer = ({currentPage}) => {
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
  const rld = JSON.parse(storage.getItem("rld"))
  const dispatch = useDispatch()
  const {selectedLoadListCompany} = useSelector((state) => state.loadList)

  const [isFilterOpen, setIsFilterOpen] = useState(false)

  const [loadCity, setLoadCity] = useState("")
  const [unLoadCity, setUnLoadCity] = useState("")
  const [isParsiyel, setIsParsiyel] = useState("")
  const [gonderici, setGonderici] = useState("")
  const [alici, setAlici] = useState("")
  const [aracPlaka, setAracPlaka] = useState("")
  const [loadDate, setLoadDate] = useState("") 
  const [truckType, setTruckType] = useState("")
  
  const [orderDataList, setOrderDataList] = useState(initialOrderDataList)

  useEffect(() => {

    const query = {
      currentPage,
      loadCity: loadCity.toLocaleLowerCase('tr'),
      unLoadCity: unLoadCity.toLocaleLowerCase('tr'),
      isParsiyel: isParsiyel?.value === 1 ? true : isParsiyel?.value === 2 ? false : "",
      loadDate: loadDate ? moment().format(loadDate): "",
      truckType,
      orderBy: orderDataList.find((item) => {
        return item.orderDirection !== "eq"
      })?.orderBy,
      orderDirection: orderDataList.find((item) => {
        return item.orderDirection !== "eq"
      })?.orderDirection,
      aracPlaka,
      gonderici,
      alici,
      companyList: selectedLoadListCompany

    }

    if(rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" || rld === "f84f35ab-0eb1-46a4-84f4-e72b236c3d26" || rld === "a7b53ef7-1cf6-4720-9b13-d9f81b5a0f99"){
      dispatch(getSeferdeListAdmin(query))
      dispatch(getTopPagesNotificationsCounts({companyList: selectedLoadListCompany}))

    }else{
      dispatch(getSeferdeList(query))
    }
    

  },[currentPage, loadCity, unLoadCity, isParsiyel, loadDate, truckType, orderDataList, aracPlaka, gonderici, alici, selectedLoadListCompany])




const handleOrderData = (updatedItemId) => {
    const updatedOrderDataList = orderDataList.map((item) => {
      if(item.id === updatedItemId){
        return {...item, orderDirection: item.orderDirection === "eq" ? "asc" : item.orderDirection === "asc" ? "desc" : "eq" }
      } 

      else{
        return {id: item.id, orderDirection: "eq", orderBy: item.orderBy}
      }
    }) 

    setOrderDataList(updatedOrderDataList)
  }

  const handleClear = () => {
    setLoadCity("")
    setUnLoadCity("")
    setIsParsiyel("")
    setLoadDate("") 
    setTruckType("")
    setAracPlaka("")
    
    setOrderDataList([
      {
        id: 1,
        orderDirection: "eq",
        orderBy: "LoadCity"
      },
      {
        id: 2,
        orderDirection: "eq",
        orderBy: "UnLoadCity"
      },
      {
        id: 3,
        orderDirection: "eq",
        orderBy: "LoadDate"
      },
    ])
  }

  return (
    <Container>
      <div className="control-container">
        <button className="filter-show-btn" onClick={() => setIsFilterOpen(!isFilterOpen)}>Filtreleri {isFilterOpen ? "Gizle" : "Göster"}</button>
        <div className="current-filter-list">
        {
            isParsiyel.text &&
            <div className="current-filter-item">Yükleme Türü: {isParsiyel.text}</div>
        }
        {
            loadCity &&
            <div className="current-filter-item">Yükleme İli: {loadCity}</div>
        }
        {
            gonderici &&
            <div className="current-filter-item">Gönderici: {gonderici}</div>
        }
        {
            loadDate &&
            <div className="current-filter-item">Yükleme Tarihi: {loadDate}</div>
        }

        {
            truckType && 
            <div className="current-filter-item">Araç Türü: {truckType}</div>
        }
        {
            unLoadCity &&
            <div className="current-filter-item">Boşaltma İli: {unLoadCity}</div>
        }


        </div>
      </div>
      {
        isFilterOpen &&

        <div className="filter-container">

          {/* //! isParsiyel filter */}
          <InputIsParsiyel data={isParsiyel} setData={setIsParsiyel} labelText={"Yükleme Türü"} name={"isParsiyel"} inputWidth={"22%"}/>


          {/* //! loadCity filter */}
          <div className="inner-grp">
            <InputSelectCity data={loadCity} setData={setLoadCity} labelText={"Yükleme İli"} name={"loadCity"} inputWidth={"calc(100% - 30px)"}/>
            <div className="arr-container" onClick={(e)=> {e.stopPropagation(); handleOrderData(orderDataList[0].id)}}>
              {
                orderDataList[0].orderDirection === "eq" &&
                <FaSort className="arr-icon"/>
              }
              {
                orderDataList[0].orderDirection === "asc" &&
                <FaSortUp className="arr-icon"/>
              }
              {
                orderDataList[0].orderDirection === "desc" &&
                <FaSortDown className="arr-icon"/>
              }
            </div>
          </div>

          <InputGonderici data={gonderici} setData={setGonderici} labelText={"Gönderici"} inputWidth={"22%"} name={"gonderici"}/> 

            {/* //! load date filter */}
            <div className="inner-grp">
                <InputYuklemeDate data={loadDate} setData={setLoadDate} labelText={"Yükleme Tarihi"} name={"loadData"} inputWidth={"calc(100% - 30px)"}/>
                <div className="arr-container" onClick={(e)=> {e.stopPropagation(); handleOrderData(orderDataList[2].id)}}>
                    {
                    orderDataList[2].orderDirection === "eq" &&
                    <FaSort className="arr-icon"/>
                    }
                    {
                    orderDataList[2].orderDirection === "asc" &&
                    <FaSortUp className="arr-icon"/>
                    }
                    {
                    orderDataList[2].orderDirection === "desc" &&
                    <FaSortDown className="arr-icon"/>
                    }
                </div>
            </div>


            {/* //! truckType filter */}
            <InputTruckType data={truckType} setData={setTruckType} labelText={"Araç Türü"} name={"truckType"} inputWidth={"22%"}/>


          {/* //! unloadCity filter */}
          <div className="inner-grp">
            <InputSelectCity data={unLoadCity} setData={setUnLoadCity} labelText={"Boşaltma İli"} name={"unloadCity"} inputWidth={"calc(100% - 30px)"}/>
            <div className="arr-container" onClick={(e)=> {e.stopPropagation(); handleOrderData(orderDataList[1].id)}}>
            {
                  orderDataList[1].orderDirection === "eq" &&
                  <FaSort className="arr-icon"/>
                }
                {
                  orderDataList[1].orderDirection === "asc" &&
                  <FaSortUp className="arr-icon"/>
                }
                {
                  orderDataList[1].orderDirection === "desc" &&
                  <FaSortDown className="arr-icon"/>
                }
              </div>
          </div>

          <InputAlici data={alici} setData={setAlici} labelText={"Alıcı"} inputWidth={"22%"} name={"alici"}/> 
         
          <InputAracPlaka data={aracPlaka} setData={setAracPlaka} labelText={"Araç Plakası"} inputWidth={"calc(22% - 30px)"} name={"aracPlaka"}/>

          <BtnOutline width={"22%"} handleClick={() => handleClear()} color={"#E85446"} bgColor="rgba(232, 26, 26, 0.065)" radius="5px" >
            Temizle
          </BtnOutline>
        </div>
      }
    </Container>
  )
}

export default SeferListTopContainer